import { useLocation } from 'react-router-dom';
import { useRouteHelper } from '../hooks/routesHelpers';

function useDetectIsLandingPage() {
  const { setRoute } = useRouteHelper();
  const location = useLocation();
  const landingPageRoute = setRoute('home');
  const landingPageRoute2 = `${landingPageRoute}/`;
  const isLandingPage = location?.pathname === landingPageRoute || location?.pathname === landingPageRoute2;

  return isLandingPage;
}

function useDetectIsFavoritePage() {
  const { setRoute } = useRouteHelper();
  const location = useLocation();
  const favoritePageRoute = setRoute('dashboard.savedHomes');
  const favoritePageRoute2 = `${favoritePageRoute}/`;
  const isFavoritePage = location?.pathname === favoritePageRoute || location?.pathname === favoritePageRoute2;

  return isFavoritePage;
}

function useDetectIsConfirmEmailPage() {
  const { setRoute } = useRouteHelper();
  const location = useLocation();
  const confirmEmailRoute = setRoute('account.confirmEmail');
  const confirmEmailRoute2 = `${confirmEmailRoute}/`;

  let isConfirmEmailPage = false; // Initialise as false
  if (location?.pathname.includes(confirmEmailRoute) || location?.pathname.includes(confirmEmailRoute2)) {
    isConfirmEmailPage = true;
  }

  return isConfirmEmailPage;
}

export { useDetectIsLandingPage, useDetectIsFavoritePage, useDetectIsConfirmEmailPage };
